<div class="subscription-page">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="loading-content">
      <div class="loading-spinner-large"></div>
      <p class="loading-text">Loading your subscription details...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loading" class="main-content">
    <!-- Header -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-section">
          <h1 class="page-title">My Subscription</h1>
          <p class="page-subtitle">Manage your account and features</p>
        </div>
      </div>
    </div>

    <!-- Subscription Status Card -->
    <div class="status-card">
      <div class="status-header">
        <div class="status-info">
          <div class="status-icon" [ngClass]="getStatusColor()">
            <mat-icon>
              {{ getStatusIcon() }}
            </mat-icon>
          </div>
          <div class="status-details">
            <h2 class="status-title">Subscription Status</h2>
            <p class="status-label" [ngClass]="getStatusColor()">
              {{ subscriptionStatus?.subscription_flag || 'Unknown' }}
            </p>
          </div>
        </div>

        <div class="status-actions" *ngIf="subscriptionStatus?.needs_subscription">
          <button class="renew-btn" (click)="upgradeSubscription()">
            <mat-icon>refresh</mat-icon>
            <span>Renew Now</span>
          </button>
        </div>
      </div>

      <div class="status-grid">
        <div class="status-item">
          <div class="status-item-label">Subscription Date</div>
          <div class="status-item-value">
            {{ subscriptionStatus?.subscription_date ? (subscriptionStatus.subscription_date | date:'mediumDate') : 'Not Set' }}
          </div>
        </div>

        <div class="status-item">
          <div class="status-item-label">Expiry Date</div>
          <div class="status-item-value">
            {{ subscriptionStatus?.expiry_date ? (subscriptionStatus.expiry_date | date:'mediumDate') : 'Not Set' }}
          </div>
        </div>

        <div class="status-item">
          <div class="status-item-label">Days Remaining</div>
          <div class="status-item-value" [ngClass]="getDaysLeftColor()">
            {{ subscriptionStatus?.days_left !== null ? subscriptionStatus.days_left + ' days' : 'N/A' }}
          </div>
        </div>

        <div class="status-item">
          <div class="status-item-label">Account Status</div>
          <div class="status-item-value">
            <span class="activity-badge" [class.active]="subscriptionStatus?.active === 1">
              <span class="activity-dot"></span>
              {{ subscriptionStatus?.active === 1 ? 'Active' : 'Inactive' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Alert Message -->
      <div *ngIf="subscriptionStatus?.needs_subscription" class="alert-message">
        <mat-icon>warning</mat-icon>
        <div class="alert-content">
          <h4>Action Required</h4>
          <p>
            {{ subscriptionStatus.message }}
          </p>
        </div>
      </div>
    </div>

    <!-- Features Section -->
    <div class="features-section">
      <div class="section-header">
        <h2 class="section-title">Available Features</h2>
        <p class="section-subtitle">Features included in your subscription plan</p>
      </div>

      <div class="features-grid">
        <div class="feature-card" *ngFor="let group of groupedFeatures | keyvalue; let i = index" [style.animation-delay.ms]="i * 150">

          <div class="feature-header">
            <div class="feature-icon">
              <mat-icon>
                {{ group.value.major.feature_name === 'Monitoring' ? 'monitoring' :
                            group.value.major.feature_name === 'Diagnostics' ? 'troubleshoot' :
                            'psychology' }}
              </mat-icon>
            </div>
            <div class="feature-info">
              <h3 class="feature-title">
                {{ group.value.major.feature_name }}
              </h3>
              <p class="feature-count">
                {{ group.value.minors.length }} sub-features
              </p>
            </div>
            <div class="feature-status">
              <span class="status-dot" [class.available]="subscriptionStatus?.active === 1"></span>
            </div>
          </div>

          <div class="feature-content">
            <div class="sub-features">
              <div class="sub-feature-item" *ngFor="let minor of group.value.minors" [class.available]="subscriptionStatus?.active === 1">
                <mat-icon class="sub-feature-icon">
                  {{ subscriptionStatus?.active === 1 ? 'check' : 'lock' }}
                </mat-icon>
                <span class="sub-feature-name">
                  {{ minor.feature_name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Subscription Actions -->
    @if (subscriptionStatus?.needs_subscription) {
    <div class="actions-section">
      <div class="action-card upgrade-card">
        <div class="action-content">
          <div class="action-icon">
            <mat-icon>trending_up</mat-icon>
          </div>
          <div class="action-info">
            <h3>Upgrade Your Plan</h3>
            <p>Get access to more advanced features and capabilities</p>
          </div>
        </div>
        <button class="action-btn upgrade-btn" (click)="upgradeSubscription()">
          <span>Upgrade Now</span>
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>

      <!-- <div class="action-card support-card">
           <div class="action-content">
             <div class="action-icon">
               <mat-icon>support_agent</mat-icon>
             </div>
             <div class="action-info">
               <h3>Need Help?</h3>
               <p>Contact our support team for assistance with your subscription</p>
             </div>
           </div>
           <button class="action-btn support-btn">
             <span>Get Support</span>
             <mat-icon>arrow_forward</mat-icon>
           </button>
         </div> -->
    </div>
    }
    @if (ON_PREM && subscriptionStatus?.needs_subscription) {
    <div class="token-verification-section">
      <div class="token-verification-card">
        <div class="token-header">
          <div class="token-icon">
            <mat-icon>vpn_key</mat-icon>
          </div>
          <div class="token-info">
            <h3>Activate Subscription</h3>
            <p>Enter your activation token to enable your subscription features</p>
          </div>
        </div>

        <form class="token-form" (ngSubmit)="verifyToken()" #tokenForm="ngForm">
          <div class="token-input-group">
            <div class="token-field">
              <label for="token">Activation Token</label>
              <input type="text" id="token" name="token" [(ngModel)]="activationToken" placeholder="Enter your activation token (e.g., ABC123-DEF456-GHI789)" required [disabled]="isVerifying" #tokenInput="ngModel" autocomplete="off" spellcheck="false">
              <div class="token-hint">
                Token format: XXX-XXX-XXX or XXXXXXXXXXXXXXXX
              </div>
            </div>
            <button type="submit" class="verify-btn" [disabled]="!tokenForm.valid || isVerifying">
              <mat-icon *ngIf="!isVerifying">verified_user</mat-icon>
              <mat-icon *ngIf="isVerifying">sync</mat-icon>
              <span>
                {{ isVerifying ? 'Verifying...' : 'Verify Token' }}</span>
            </button>
          </div>

          <!-- Validation Messages -->
          <div *ngIf="tokenInput.invalid && tokenInput.touched" class="token-status error">
            <mat-icon>error</mat-icon>
            <span>Please enter a valid activation token</span>
          </div>

          <!-- Verification Status Messages -->
          <div *ngIf="verificationStatus" class="token-status" [ngClass]="verificationStatus.type">
            <mat-icon *ngIf="verificationStatus.type === 'success'">check_circle</mat-icon>
            <mat-icon *ngIf="verificationStatus.type === 'error'">error</mat-icon>
            <mat-icon *ngIf="verificationStatus.type === 'loading'">sync</mat-icon>
            <span>
              {{ verificationStatus.message }}</span>
          </div>
        </form>

        <!-- Token Information -->
        <div class="token-examples">
          <h4>Token Information</h4>
          <ul>
            <li>Tokens are case-insensitive and can contain letters, numbers, and hyphens</li>
            <li>Format examples: <code>ABC123-DEF456-GHI789</code> or <code>ABCDEF123456789</code></li>
            <li>Contact support if you don't have an activation token</li>
            <li>Each token can only be used once and expires after 30 days</li>
          </ul>
        </div>
      </div>
    </div>
    }
  </div>
</div>
@if (showRequestTokenModal) {
<div class="modal-overlay">
  <div class="modal-carwd">
    <div class="modal-header">
      <mat-icon class="modal-icon" color="primary">help_outline</mat-icon>
      <h3 class="modal-title">
        {{ modalTitle }}
      </h3>
    </div>
    <div class="modal-body">
      <p>
        {{ modalMessage }}
      </p>
    </div>
    <div class="modal-footer">
      <button mat-stroked-button (click)="closeRequestTokenModal()" style="color: red !important; border: 1px solid red !important;">Cancel</button>
      @if (!ON_PREM) {
      @if (isMailReceived) {
      <button mat-raised-button color="primary" disabled style="color: gray; border: 1px solid gray; cursor: not-allowed;">Token Request Sent</button>
      } @else {
      <button mat-raised-button color="primary" (click)="requestTokenFromAdmin()" [disabled]="sendingRequestToken">
        {{ sendingRequestToken ? 'Sending...' : 'Request Token' }}
      </button>
      }
      }
    </div>
  </div>
</div>
}
